import { render, staticRenderFns } from "./indoorareas.vue?vue&type=template&id=5124c483&scoped=true"
import script from "./indoorareas.vue?vue&type=script&lang=js"
export * from "./indoorareas.vue?vue&type=script&lang=js"
import style0 from "./indoorareas.vue?vue&type=style&index=0&id=5124c483&prod&scoped=true&lang=css"
import style1 from "./indoorareas.vue?vue&type=style&index=1&id=5124c483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124c483",
  null
  
)

export default component.exports